import React from 'react';
import packageJson from '../../package.json';
global.appVersion = packageJson.version;



export default class CacheBuster extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            isLatestVersion: false,
            refreshCacheAndReload: () => {
                console.log('Clearing cache and hard reloading...')
                
                // delete browser cache and hard reload               
                setTimeout(() => { window.location.reload(true) }, 10000);
                setTimeout(() => { console.log("reload finished") }, 10000);
            }
        };
    }

    componentDidMount() {
        var url;
        if (window.location.hostname == 'localhost') {
            url = '/meta.json'
            console.log('local call ran')
        }
        else {
            url = '/cdb/meta.json'
            console.log('cdb call ran')
        }
        fetch(url, {
            headers: {
                'pragma': 'no-cache',
                'cache-control': 'no-cache',
              /*  'Cache-control': 'no-store'*/
            },
        })
            .then((response) => response.json())
            .then((meta) => {
                const latestVersion = meta.version;
                const currentVersion = global.appVersion;

                if (latestVersion !== currentVersion) {
                    console.log(`We have a new version - ${latestVersion}. Should force refresh`);
                    console.log('current version is', currentVersion)
                    this.setState({ loading: false, isLatestVersion: false });
                } else {
                    console.log(`You already have the latest version - ${latestVersion}. No cache refresh needed.`);
                    console.log('current version is', currentVersion)
                    this.setState({ loading: false, isLatestVersion: true });
                }
            })
            .catch((error) => {
                console.log("in error")
                console.log(error)
            });
    }

    render() {
        const { loading, isLatestVersion, refreshCacheAndReload } = this.state;
        return this.props.children({ loading, isLatestVersion, refreshCacheAndReload });
    }
}